/* ═══ Theme-aware chart color helpers ═══ */

/**
 * Returns computed HSL color from a CSS variable.
 * Falls back to provided default hex if variable is unavailable.
 */
function cssVar(name) {
  if (typeof window === 'undefined') return '';
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return raw ? `hsl(${raw})` : '';
}

/** Primary brand blue — charts, main data series */
export function chartBlue() { return cssVar('--chart-1') || '#3B82F6'; }

/** Stable green — positive trends, growth */
export function chartGreen() { return cssVar('--chart-2') || '#22C55E'; }

/** Warning amber — risk, caution */
export function chartAmber() { return cssVar('--chart-3') || '#F59E0B'; }

/** Destructive red — negative trends, alerts */
export function chartRed() { return cssVar('--chart-4') || '#EF4444'; }

/** Purple — secondary series, variety */
export function chartPurple() { return cssVar('--chart-5') || '#8B5CF6'; }

/** Background for chart tooltips */
export function chartTooltipBg() { return cssVar('--card') || '#1C1F24'; }

/** Border for chart elements */
export function chartBorder() { return cssVar('--border') || '#2D3139'; }

/** Muted text for axes/labels */
export function chartMuted() { return cssVar('--muted-foreground') || '#8B929E'; }
